import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listSuperTenants, type SuperTenantRow } from "../api/super";
import { ApiError } from "../api/client";
import { PageHeader } from "../components/Chrome";
import { StatusPill } from "../components/primitives";

// S1 — all-tenants list (Foundry team only).
export function SuperTenantsList() {
  const [rows, setRows] = useState<SuperTenantRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        setRows(await listSuperTenants());
      } catch (e) {
        setError(e instanceof ApiError ? e.detail : (e as Error).message);
      }
    })();
  }, []);

  return (
    <div className="container">
      <PageHeader title="All tenants" eyebrow="Foundry super-admin" />
      {error && <div className="empty err">{error}</div>}
      {rows === null && !error && <div className="empty">Loading…</div>}
      {rows && rows.length === 0 && (
        <div className="empty">No tenants provisioned.</div>
      )}
      {rows && rows.length > 0 && (
        <table className="ppl-table">
          <thead>
            <tr>
              <th>Display name</th>
              <th>Slug</th>
              <th>Domain</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((t) => (
              <tr key={t.slug}>
                <td>{t.display_name}</td>
                <td><code>{t.slug}</code></td>
                <td>{t.domain ?? "—"}</td>
                <td><StatusPill status={t.status} /></td>
                <td>
                  <Link to={`/admin/super/${t.slug}`} className="btn-link">
                    Open →
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
